import { env } from '../env';

export const logout = () => {
  fetch(env.VITE_ACCOUNT_API_URL + '/logout', {
    credentials: 'include'
  }).then(() => {
    location.href = env.VITE_ACCOUNT_UI_URL;
  });
};
